// Lấy chi tiết phim theo id (hoặc slug)
export const getDetailFilm = async (value) => {
  const res = await fetch(`https://phimapi.com/phim/${value}`);
  const result = await res.json();
  return result;
};

// Lấy danh sách phim mới cập nhật
export const getListFilm = async () => {
  const response = await fetch(`https://phimapi.com/danh-sach/phim-moi-cap-nhat`);
  const result = await response.json();
  return result;
};
